import styled, { css } from "styled-components";
import { Form as FormikForm } from "formik";

export const Form = styled(FormikForm)<{ $variant: "full" | "zipCodeOnly" }>`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.spacing_16};

  ${props => props.theme.breakpointsV2.smallTablet} {
    display: grid;
    grid-template-columns: auto minmax(200px, 1fr) auto;

    ${props =>
      props.$variant === "zipCodeOnly" &&
      css`
        grid-template-columns: 1fr auto;
      `}
  }
`;
